// @flow

import * as React from 'react';

import { Outlet } from 'react-router-dom';
import { compose } from 'redux';

import { retrieveCart } from '@gandi/cart';
import { withTranslator, type TranslatorProps } from '@gandi/translate';

import { retrievePricing, addServicesOnConnect } from '../modules/app/actions';
import type { ComponentWithPrefetch, PreFetchArgs } from '../types';

import { CartTray } from './CartTray';

type Params = {
  cartId?: string,
};

export type Props = {
  backgroundColor?: string,
  params?: Params,
  showCartTray?: boolean,
  // eslint-disable-next-line react/no-unused-prop-types
  translator: TranslatorProps, // Use in the Prefetch
};

function RootWithPreFetch({
  backgroundColor,
  showCartTray,
}: Props): React.MixedElement {
  return (
    <>
      <Outlet context={{ backgroundColor }} />
      {showCartTray && <CartTray />}
    </>
  );
}

/**
 * Retrieve the current/latest cart
 * Retrieve and save guessed currency:
 * - if not authenticated
 * - if authenticated but minimal org (does not have a bu_id)
 * - bypassed if ?currency=EUR querystring parameter is present
 */
RootWithPreFetch.preFetch = async function preFetch(
  args: PreFetchArgs<Props, Params>,
): Promise<any> {
  return Promise.allSettled([
    args
      .dispatch(retrieveCart(args.params?.cartId))
      .then(() => args.dispatch(addServicesOnConnect(args.translator))),
    args.dispatch(
      // $FlowFixMe[incompatible-call]
      retrievePricing(args.req.query.currency, args.req.query.taxes),
    ),
  ]);
};

export default (compose(withTranslator({ propsNamespace: 'translator' }))(
  RootWithPreFetch,
): ComponentWithPrefetch<
  $Diff<Props, { translator: TranslatorProps }>,
  typeof RootWithPreFetch.preFetch,
>);
